import React, { FC } from "react";
import {
  Checkbox,
  Chip,
  FormControl,
  InputLabel,
  ListItemText,
  ListSubheader,
  MenuItem,
  Select,
  SelectChangeEvent,
  Theme,
} from "@mui/material";

import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import "./style.css";
import { grupoRegioes } from "src/components/componentes/forms/BaseForm";
import { InputSelectProperties } from "../InputSelect";
import theme from "src/theme/light";

export interface Regiao {
  id: number;
  nome: string;
  grupo: string;
  created_at?: string | Date | null;
  updated_at?: string | Date | null;
}

export interface InputSelectRegioesProperties extends InputSelectProperties {
  list: Regiao[];
  value: number[];
  onChange(value: any): void;
}

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const useStyles = makeStyles((_theme: Theme) =>
  createStyles({
    formControl: {
      //margin: theme.spacing(1),
      minWidth: 120,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    menuHeader: {
      backgroundColor: theme.palette.background.default,
    },
    chip: {
      margin: 2,
    },
  })
);

const InputSelectRegioes: FC<InputSelectRegioesProperties> = (
  props: InputSelectRegioesProperties
) => {
  const classes = useStyles();

  const regioesMacro =
    props?.list?.filter(
      (regiao: Regiao) => regiao.grupo === grupoRegioes.REGIOES
    ) || [];

  const estados =
    props?.list?.filter(
      (regiao: Regiao) => regiao.grupo === grupoRegioes.ESTADOS
    ) || [];

  const outros =
    props?.list?.filter(
      (regiao: Regiao) =>
        regiao.grupo !== grupoRegioes.REGIOES &&
        regiao.grupo !== grupoRegioes.ESTADOS
    ) || [];

  const [selectedValues, setSelectedValues] = React.useState<number[]>(
    props.value
  );

  const handleChange = (event: SelectChangeEvent<number[]>) => {
    const selecteds: number[] = event.target.value as number[];
    setSelectedValues([...selecteds]);
    if (props.onChange) {
      props.onChange(
        props.list.filter((reg: Regiao) => selecteds.indexOf(reg.id) > -1)
      );
    }
  };

  return (
    <FormControl
      fullWidth={true}
      variant="outlined"
      size={"small"}
      className={classes.formControl}
    >
      <InputLabel
        id="select-regioes-label"
        style={{ backgroundColor: "#fff", padding: "0px 1px" }}
      >
        {props.label}
      </InputLabel>
      <Select
        style={{ textAlign: "left" }}
        labelId="select-regioes-label"
        id="regiao-mutiple-checkbox"
        multiple
        value={props.value}
        onChange={handleChange}
        renderValue={(selected) => {
          const selectedRegiao: Regiao[] =
            props.list.filter(
              (reg: Regiao) => (selected as number[]).indexOf(reg.id) > -1
            ) || [];
          return (
            <div className={classes.chip}>
              {selectedRegiao.map((regiao) => (
                <Chip
                  key={regiao.id}
                  label={regiao.nome}
                  className={classes.chip}
                  size={"small"}
                />
              ))}
            </div>
          );
        }}
        MenuProps={MenuProps}
      >
        <ListSubheader className={classes.menuHeader}>
          {grupoRegioes.REGIOES}
        </ListSubheader>
        {regioesMacro.map((_regiao: Regiao) => (
          <MenuItem key={_regiao.nome} value={_regiao.id}>
            <Checkbox checked={selectedValues.includes(_regiao.id)} />
            <ListItemText primary={_regiao.nome} />
          </MenuItem>
        ))}
        <ListSubheader className={classes.menuHeader}>
          {grupoRegioes.ESTADOS}
        </ListSubheader>
        {estados.map((estado: Regiao) => (
          <MenuItem key={estado.nome} value={estado.id}>
            <Checkbox checked={selectedValues.includes(estado.id)} />
            <ListItemText primary={estado.nome} />
          </MenuItem>
        ))}

        <ListSubheader className={classes.menuHeader}>
          {grupoRegioes.OUTROS}
        </ListSubheader>
        {outros.map((outro: Regiao) => (
          <MenuItem key={outro.nome} value={outro.id}>
            <Checkbox checked={selectedValues.includes(outro.id)} />
            <ListItemText primary={outro.nome} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export { InputSelectRegioes };
